// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;

/*
render function
*/
import { desThumbnailRenderFunction } from 'js/desThumbnailService';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/desThumbnailService', () => import('js/desThumbnailService'));
registerDynImportEntry('js/desSearchService', () => import('js/desSearchService'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "actions": {
    "render": {
      "method": "desThumbnailRenderFunction",
      "deps": "js/desThumbnailService"
    },
    "loadUrl": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "query": "query getThumbnailUrl( $item: Json) { getThumbnailUrl( item: $item) }",
            "variables": {
              "item": "{{props.vmo.originalObj}}"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{props.accsessionid}}"
      },
      "outputData": {
        "url": "data.data.getThumbnailUrl"
      },
      "deps": "js/desSearchService"
    }
  },
  "data": {},
  "conditions": {},
  "onEvent": [],
  "lifecycleHooks": {
    "render": "render",
    "onMount": "loadUrl"
  },
  "props": {
    "vmo": {
      "type": "viewModelObject"
    },
    "accsessionid": {
      "type": "string"
    }
  },
  "_viewModelId": "DesThumbnail",
  "_uniqueViewModelId": "DesThumbnail",
  "ctx": {}
};

/*
define component
*/
const Component = createComponent(declViewModelJson, desThumbnailRenderFunction, undefined, ctxImportObj);
export default Component;